// extracted by mini-css-extract-plugin
export var promotionLink = "_vl-0";